<div
class="toast toast--success text-white"
role="alert"
aria-live="assertive"
aria-atomic="true"
>
<div class="toast-body">
  <div class="toast__wrapper">
    <div class="toast__icon">
      <svg width="30px" height="30px" viewBox="0 0 30 30" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <title>Icons / Success</title>
          <defs>
              <filter id="filter-1">
                  <feColorMatrix in="SourceGraphic" type="matrix" values="0 0 0 0 45.000000 0 0 0 0 301.000000 0 0 0 0 127.000000 0 0 0 1.000000 0"></feColorMatrix>
              </filter>
          </defs>
          <g id="Style-Guide" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g id="Misc" transform="translate(-617.000000, -529.000000)">
                  <rect x="0" y="0" width="2913" height="1000"></rect>
                  <g id="Icons" transform="translate(50.000000, 459.000000)">
                      <g transform="translate(0.000000, 68.000000)" id="Icons-/-Success">
                          <g transform="translate(567.209302, 2.000000)">
                              <g id="Color">
                                  <g>
                                      <path d="M15,0 C6.73333333,0 0,6.7 0,15 C0,23.2666667 6.73333333,30 15,30 C23.2666667,30 30,23.2666667 30,15 C30,6.7 23.2666667,0 15,0 Z M22.5666667,11.0666667 L13.0666667,20.5666667 C12.9333333,20.7 12.7666667,20.7666667 12.6,20.7666667 C12.4333333,20.7666667 12.2666667,20.7 12.1333333,20.5666667 L7.46666667,15.9 C7.2,15.6333333 7.2,15.2333333 7.46666667,14.9666667 C7.73333333,14.7 8.13333333,14.7 8.4,14.9666667 L12.6,19.1666667 L21.6333333,10.1333333 C21.9,9.86666667 22.3,9.86666667 22.5666667,10.1333333 C22.8333333,10.3666667 22.8333333,10.8 22.5666667,11.0666667 Z" id="Shape" fill="#25C157"></path>
                                  </g>
                              </g>
                          </g>
                      </g>
                  </g>
              </g>
          </g>
      </svg>
    </div>
    <div class="toast__content">
      <div class="toast__type  text-dark">Success</div>
      <div class="toast__message">{{message}}</div>
    </div>
  </div>
</div>
</div>
